import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionBon {
    /**
     * Quand on clique sur un mouvement, puis imprimer le bon correspondant
     * @param clefMouvCourant : mouvementCourant.clefMouvCourant
     * @param format : ex: formatBon.xml
     * @param clefSite
     * @param common
     */
    public static imprimerBonEcoBenne(clefMouvCourant, format, common: CommonService) {
        let nomBDHolding = '';
        const societe = common.local.getObject('paramSociete') || {};
        if (societe.isAppartientHolding) {
          nomBDHolding = common.local.getObject('nomBDHolding') ? common.local.getObject('nomBDHolding').nomBDHolding : '';
        }          
                
        const param = {
            'servlet': 'DBImprimeBonEcobennes',
            'module': 'Ecobennes',
            'type': 'tableau',
            'compression': 'false',
            'pathImpression': 'Ecobennes/tmp/BonEcobennes/',
            'data': [
                'DBImprimeBonEcobennes',
                '' + clefMouvCourant,
                format,
                '' + common.user[2],
                0, // formatParam
                '', // PRINT_PESEE
                nomBDHolding
            ]
        };

        return common.post('', { param: param });
    }

    public static imprimerBonEcoBenneFP(clefMouvCourant, clefFormatParam, printPesee, common: CommonService) {
        console.log('Calling imprimerBonEcoBenneFP ()', clefMouvCourant);
        let nomBDHolding = '';
        const societe = common.local.getObject('paramSociete') || {};
        if (societe.isAppartientHolding) {
          nomBDHolding = common.local.getObject('nomBDHolding') ? common.local.getObject('nomBDHolding').nomBDHolding : '';
        }                  
        
        let clefMouvSansRedondance = [];
        clefMouvSansRedondance = clefMouvCourant.filter((value, index, self) => {
            return self.indexOf(value) === index;
        });        

        const param = {
            'servlet': 'DBImprimeBonEcobennes',
            'module': 'Ecobennes',
            'type': 'map',
            'compression': 'false',
            'pathImpression': 'Ecobennes/tmp/BonEcobennes/',
            'data': {
                'CLEF_MOUV': '0',
                'FORMAT': '',
                'CLEF_SITE': {
                    'typeParam': 'int',
                    'valeur': common.user[2]
                },
                'CLEF_FORMAT': {
                    'typeParam': 'int',
                    'valeur': clefFormatParam
                },
                'PRINT_PESEE': {
                    'typeParam': 'boolean',
                    'valeur': printPesee
                },
                'IS_MERGE': {
                    'typeParam': 'boolean',
                    'valeur': true
                },
                'LISTE_CLEF_MOUV': clefMouvSansRedondance,
                'BD_HOLDING': nomBDHolding
            }
        };

        return common.post('', { param: param });
    }

    public static async appelDetailmouv(listMouvCourant, common, index?) {
        index = index || 0;
        if (index < listMouvCourant.length) {
            this.getDetailMouvAfterPrintBon(listMouvCourant[index], common).then(() => {
                this.appelDetailmouv(listMouvCourant, common, index + 1);
            });
        }
    }

    public static async getDetailMouvAfterPrintBon(id, common) {
        const list1 = common.getType('listOperationSupp') || [];
        const list2 = common.getType('listOperationSuppBennePlace') || [];
        const societe = common.local.getObject('paramSociete') || {};
        const ListOP = [...list1, ...list2];
        const param = {
            'servlet': 'DBGestionEquipeBenne',
            'module': 'Ecobennes',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                    'typeParam': 'int',
                    'valeur': 8
                },
                'CLEF_MOUV': {
                    'typeParam': 'int',
                    'valeur': id
                },
            }
        };

        return await common.post('', { param: param }).then(datas => {
            if (common.verifySession(datas)) {
                const mouvement = datas.data || { id: id };
                let isSortie = false;
                if ((mouvement.tournee && mouvement.tournee.id) || (!mouvement.listBenne ||
                    (mouvement.listBenne && !mouvement.listBenne.length))) {
                    isSortie = mouvement.operationBenne && mouvement.operationBenne.sortie ? true : false;
                } else {
                    if (mouvement.listBenne) {
                        mouvement.listBenne.forEach(BenneData => {
                            const OperationBenne = ListOP.filter(elt => BenneData.operationBenne &&
                                BenneData.operationBenne.id === elt.id);
                            if (OperationBenne.length) {
                                BenneData.operationBenne = OperationBenne[0];
                            }
                        });

                        const existeSortie = mouvement.listBenne.filter(BenneData => BenneData.operationBenne &&
                            BenneData.operationBenne.sortie);
                        isSortie = existeSortie.length ? true : false;
                    }
                }

                if (isSortie) {
                    if (mouvement.listeBon) {
                        mouvement.listeBon.forEach(Bon => {
                            if (Bon.chantier && Bon.chantier.paysObjet && societe.pays && Bon.chantier.paysObjet.id !== societe.pays.id) {
                                this.DBImprimeListeVerte(Bon, common);
                            }
                        });
                    } else {
                        if (mouvement.bon && mouvement.bon.chantier && mouvement.bon.chantier.paysObjet && societe.pays &&
                            mouvement.bon.chantier.paysObjet.id !== societe.pays.id) {
                            this.DBImprimeListeVerte(mouvement.bon, common);
                        }
                    }
                }
            }
        });
    }


    public static async  DBImprimeListeVerte(bon, common: CommonService) {
        if (bon) {
            bon.nomclass = 'Bon';
            const param = {
                'servlet': 'DBImprimeListeVerte',
                'module': 'Recylog',
                'type': 'liste',
                'compression': 'false',
                'pathImpression': 'Recylog/tmp/',
                'data': [
                    ['DBImprimeListeVerte'],
                    bon,
                    {
                        'typeParam': 'int',
                        'valeur': 0
                    },
                    {
                        'typeParam': 'boolean',
                        'valeur': false
                    },
                    {
                        'typeParam': 'boolean',
                        'valeur': true
                    }
                ]
            };

            return await common.post('', { param: param }).then(datas => {
                if (common.verifySession(datas)) {
                    if (datas.data && datas.data.length) {
                        common.openFile(datas.data[0]);
                    }
                }
            });
        }

    }

    /**
     * Impression planning d'un chauffeur
     * @param clefCamion
     * @param date
     * @param clefPeriode
     * @param clefFormatParam
     * @param clefChauffeur
     * @param common
     */
    public static imprimerPlanningChauffeurEcoBenne(clefCamion, date, clefPeriode, clefFormatParam,
        clefChauffeur, common: CommonService, MAP_CAMION_CHAUFFEUR, LISTE_CLEF_BONS?, FORMAT?, FORMAT_COLLECTE_SELECTIVE?) {
        /*const param = {
            'servlet': 'DBImprimePlanningPDF',
            'module': 'Ecobennes',
            'type': 'tableau',
            'compression': 'false',
            'pathImpression': 'Ecobennes/tmp/Planning/',
            'data': [
                ['DBImprimePlanningPDF'],
                clefCamion,
                date,
                '' + common.user[2],
                '' + clefPeriode,
                '',
                '0',
                'false',
                clefFormatParam,
                clefChauffeur
                // []
            ]
        };*/

        const param = {
            'servlet': 'DBImprimePlanningPDF',
            'module': 'Ecobennes',
            'type': 'map',
            'compression': 'false',
            'pathImpression': 'Ecobennes/tmp/Planning/',
            'data': {
                /*'DATE': date,*/
                'CLEF_SITE': {
                    'typeParam': 'int',
                    'valeur': common.user[2]
                },
                'CLEF_FORMAT': {
                    'typeParam': 'int',
                    'valeur': 0
                },
                /*'CLEF_PERIODE': '' + clefPeriode,*/
                'PERIODE': '0',
                'MAP_CAMION_CHAUFFEUR': MAP_CAMION_CHAUFFEUR, 
                'ACTUALISER_LIBELLE_NEGOCIEE': {
                  'typeParam': 'boolean',
                  'valeur': true  
                }
            }
        };

        if (LISTE_CLEF_BONS) {
            param['data']['LISTE_CLEF_BONS'] = LISTE_CLEF_BONS || [];
        }

        if (FORMAT) {
            param['data']['FORMAT'] = FORMAT || '';
        }
        if (FORMAT_COLLECTE_SELECTIVE) {
            param['data']['FORMAT_COLLECTE_SELECTIVE'] = FORMAT_COLLECTE_SELECTIVE || '';
        }
        return common.post('', { param: param });
    }

    public static supprimerBonEcoBenne(clefMouvCourant, benneId, raison, common: CommonService) {
        const userDetail = common.local.getObject('userDetail');

        const param = {
            'servlet': 'DBSuppMouv',
            'module': 'Recylog',
            'type': 'tableau',
            'compression': 'false',
            'data': [
                'DBSuppMouv',
                '' + (clefMouvCourant || 0),
                '' + (benneId || 0),
                '',
                userDetail.login,
                raison,
                '' + userDetail.id
            ]
        };

        return common.post('', { param: param });
    }
}
